import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../constants/Routes';

const TITLE_MAP = {
    '/': 'Home',
    ['/' + ROUTES.PRODUCTS]: 'Products',
    ['/' + ROUTES.SERVICES]: 'Services',
    ['/' + ROUTES.ABOUT_US]: 'About Us',
    ['/' + ROUTES.INSTALLED_PROJECTS]: 'Recently Installed',
    ['/' + ROUTES.PRODUCT_DETAILS]: 'Product Details',
    ['/' + ROUTES.PRODUCTS + '/' + ROUTES.PRODUCT_DETAILS]: 'Product Details',
    ['/' + ROUTES.SERVICES + '/' + ROUTES.PRODUCT_DETAILS]: 'Service Details',
    ['/' + ROUTES.INSTALLED_PROJECTS + '/' + ROUTES.PRODUCT_DETAILS]: 'Project Details',
};

const BRAND = 'Hundredfolds Industries';

const PageTitle = () => {
    const location = useLocation();

    useEffect(() => {
        const page = TITLE_MAP[location.pathname];
        document.title = page ? `${page} | ${BRAND}` : BRAND;
    }, [location.pathname]);

    return null;
};

export default PageTitle;
